<template>
  <span v-if="isValidInput" :class="cssClass" style="white-space: nowrap">{{ formattedDate }}</span>
  <v-icon v-else>remove</v-icon>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppDate',
  props: {
    date: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: null
    },
    defaultText: {
      type: String,
      default: null
    },
    cssClass: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      today: null,
      yesterday: null,
      timeFormat: 'h:mm a'
    }
  },
  computed: {
    ...mapGetters(['locale']),
    isValidDate () {
      return this.date !== null
        ? this.date.length > 0
        : false
    },
    isValidInput () {
      // invalid if no date or default text was supplied
      return this.isValidDate
        ? true
        : this.defaultText !== null
    },
    momentDate () {
      return this.isValidDate
        ? this.$moment(this.date)
        : null
    },
    formattedDate () {
      if (this.momentDate !== null) {

          // user has request a default format   
          if (this.format !== null) {
            return this.momentDate.format(this.format)
          }

          // derive formatted date
          if (this.isToday) {
              return `${this.getExpression('Label', 'Today')}, ${this.momentDate.format(this.timeFormat)}`
          } else if (this.isYesterday) {
              return `Yesterday, ${this.momentDate.format(this.timeFormat)}`
          } else if (this.isThisYear) {
              return this.momentDate.format(`ddd MMM D, ${this.timeFormat}`)
          } else {
              return this.momentDate.format(`MMM D YYYY, ${this.timeFormat}`)
          }
      }
      return this.defaultText
    },
    isToday () {
      return this.momentDate != null
        ? this.momentDate.isSame(this.today, 'd')
        : false
    },
    isYesterday () {
      return this.momentDate != null
        ? this.momentDate.isSame(this.yesterday, 'd')
        : false
    },
    isThisYear () {
      return this.momentDate != null
        ? this.momentDate.isSame(this.today, 'y')
        : false
    }
  },
  mounted() {
    this.$moment.locale(this.locale)
    const now = this.$moment()
    this.today = now.clone().startOf('day')
    this.yesterday = now.clone().subtract(1, 'days').startOf('day')
  }
}
</script>
